import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Two_Way_1: React.FC<Props> = ({ fill }) => {
    return (
        <Svg id="Layer_1" width="12pt" height="100%" viewBox="0 0 32 32" fill={fill}>
            <Path d="m1 11.859c0 .553.447 1 1 1h28c.404 0 .77-.243.924-.617.155-.374.069-.804-.217-1.09l-4.305-4.305c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.598 2.598h-25.586c-.553 0-1 .448-1 1z" />
            <Path d="m30 19.141h-28c-.404 0-.77.243-.924.617-.155.374-.069.804.217 1.09l4.305 4.305c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-2.598-2.598h25.586c.553 0 1-.447 1-1s-.447-1-1-1z" />
        </Svg>
    );
};
export default Two_Way_1;
